// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".piano-opt-out_opt-out_3yMHv label {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.piano-opt-out_opt-out_3yMHv input {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin: 0;\n  cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"optOut": "piano-opt-out_opt-out_3yMHv"
};
module.exports = exports;
